import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import Dictionary from '../Dictionary'
import Logo from '../../assets/images/img-web/logo_abbinarybag.svg'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

const NavBarComponent = (props) => {
  const { onClick } = props
  return (
    <Navbar collapseOnSelect expand='lg' variant='dark' className='w-100 px-3' id='custom-navbar'>
      <Navbar.Toggle aria-controls='basic-navbar-nav' />
      <Navbar.Brand>
        <Link to='/inicio' onClick={onClick} className='d-lg-block ml-lg-4 d-none'>
          <img src={Logo} alt='logo' className='logo-navbar d-inline-block align-top' />
        </Link>
      </Navbar.Brand>
      <Navbar.Collapse id='navbarSupportedContent'>
        <Nav className='ml-auto'>
          <NavLink className='nav-link' activeClassName='active' to='/inicio' onClick={onClick}>{Dictionary.index}</NavLink>
          <span className='my-2 mx-4 d-none d-lg-block'>|</span>
          <NavLink className='nav-link' activeClassName='active' to='/que-hacemos' onClick={onClick}>{Dictionary.what_we_do}</NavLink>
          <span className='my-2 mx-4 d-none d-lg-block'>|</span>
          <NavLink className='nav-link' activeClassName='active' to='/quienes-somos' onClick={onClick}>{Dictionary.who_we_are}</NavLink>
          <span className='my-2 mx-4 d-none d-lg-block'>|</span>
          <NavLink className='nav-link' activeClassName='active' to='/clientes' onClick={onClick}>{Dictionary.clients}</NavLink>
          <span className='my-2 mx-4 d-none d-lg-block'>|</span>
          <NavLink className='nav-link' activeClassName='active' to='/contacto' onClick={onClick}>{Dictionary.contact}</NavLink>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
} 

export default NavBarComponent
